export default __webpack_public_path__ + "static/media/wallet.ecb76657.jpg";